export default __webpack_public_path__ + "static/media/sh2_7.264f2332.jpg";